<template lang="pug">
  div
    el-row
      divider(label="Dados do Cartório")

    el-row(:gutter="24" type="flex")
      el-col(:span="8").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Selecione o(s) Município(s):")
          el-select.full-width.input(
            filterable
            v-model='idsMunicipios'
            :class="{'erro' : errors.length}"
            multiple
            @change="getCartoriosByMunicipios"
          )
            el-option(
              v-for='municipio in municipios'
              :key='municipio.id',
              :label='municipio.nome'
              :value='municipio.id'
            )
          span.help.erro {{ errors[0] }}
      el-col(:span="10").container-input
        validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Selecione o(s) cartorio(s):")
          el-select.full-width.input(
            v-model="cartoriosSelecionados",
            :class="{'erro' : errors.length}",
            multiple,
            value-key="id"
            filterable,
            placeholder="Selecione o(s) cartorio(s)",
            @change="changeCartorios",
            no-match-text="Nenhum cartorio encontrado",
          )
            el-option-group(
              v-for="municipio in municipiosComCartorio",
              :label="municipio.nome",
              :key="municipio.id",
            )
              el-option(
                v-for="cartorio in municipio.cartorios"
                :key="cartorio.id",
                :label="cartorio.nome",
                :value="cartorio"
              )
          span(v-if="errors[0]").help.erro {{errors[0]}}
      el-col(:span="4").container-input.align-center
        slot

</template>

<script>
import { mapActions } from 'vuex'
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    Divider,
    AppLabel
  },

  data () {
    return {
      municipios: [],
      idsMunicipios: [],
      cartorios: [],
      municipiosComCartorio: [],
      cartoriosSelecionados: []
    }
  },

  async created () {
    this.municipios = (await this.findMunicipiosByEstadoAtual()) || []
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual:
        'municipios/findMunicipiosByEstadoAtualPromise',
      findCartorioByMunicipiosIds:
        'cartorioArrecadacao/findCartorioByMunicipiosIds'
    }),

    async getCartoriosByMunicipios () {
      this.cartorios = await this.findCartorioByMunicipiosIds(
        this.idsMunicipios
      )
      this.municipiosComCartorio = this.agruparCartorios(this.cartorios)
    },

    agruparCartorios (cartorios) {
      const cartoriosGrupo = {}
      if (cartorios) {
        cartorios.forEach(cartorio => {
          const municipio = cartorio.municipio
            ? cartorio.municipio.nome
            : 'Outro'
          if (!cartoriosGrupo[municipio]) {
            cartoriosGrupo[municipio] = {
              id: municipio.id,
              nome: municipio,
              cartorios: []
            }
          }
          cartoriosGrupo[municipio].cartorios.push(cartorio)
        })
      }

      return cartoriosGrupo
    },

    async changeCartorios () {
      this.$emit('atualizarListaCartorios', this.cartoriosSelecionados)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-input {
  margin-right: 20px;
}
input {
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}
.full-width {
  width: 100%;
  margin-right: none;
}

.align-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppDadosCartorio.vue